import ApplyNav from "@/components/apply/ApplyNav";
import {
  ApplyHero,
  SeriousApplicants,
  OnTheCall,
  ApplyProof,
  BookingSection,
  CalendarSection,
} from "@/components/apply/ApplySections";
import Footer from "@/sections/Footer";

// "/apply" — original apply page, same section order and copy word for
// word, restyled with the shared 7FCC blue/silver system.
export default function ApplyPage() {
  return (
    <main className="overflow-x-clip bg-ink-950 font-sans text-fg">
      <ApplyNav />
      <ApplyHero />
      <SeriousApplicants />
      <OnTheCall />
      <ApplyProof />
      <BookingSection />
      <CalendarSection />
      <Footer />
    </main>
  );
}
